import { Navigation, Footer } from "@/components/Layout";
import { SEO } from "@/components/SEO";

export default function Privacy() {
  return (
    <div className="min-h-screen bg-white" data-testid="privacy-page">
      <SEO 
        title="Privacy Policy"
        description="Steward Lots privacy policy. We respect your data and never sell it to third parties. Plain-language explanation of how your information is used."
        path="/privacy"
      />
      <Navigation mode="builder" />

      <div className="pt-24 pb-16 px-6 md:px-12">
        <div className="max-w-3xl mx-auto">
          <h1 className="font-serif text-3xl md:text-4xl text-[#1C1917] mb-8">
            Privacy Policy
          </h1>
          
          <div className="prose prose-lg max-w-none text-[#57534E]">
            <p className="text-sm text-[#A8A29E] mb-8">
              Last updated: {new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}
            </p>

            <section className="mb-8">
              <h2 className="font-serif text-xl text-[#1C1917] mb-4">Introduction</h2>
              <p>
                Steward Lots™ ("we," "our," or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website or submit information through our forms.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-serif text-xl text-[#1C1917] mb-4">Information We Collect</h2>
              <p>We may collect information you provide directly to us, including:</p>
              <ul className="list-disc pl-6 mt-2 space-y-2">
                <li>Name, email address, and phone number</li>
                <li>Property information (address, county, acreage, etc.)</li>
                <li>Business information (company name, buying criteria)</li>
                <li>Prayer requests and messages you submit</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="font-serif text-xl text-[#1C1917] mb-4">How We Use Your Information</h2>
              <p>We use the information we collect to:</p>
              <ul className="list-disc pl-6 mt-2 space-y-2">
                <li>Respond to your inquiries and fulfill your requests</li>
                <li>Send you information about properties or opportunities matching your criteria</li>
                <li>Process and facilitate land transactions</li>
                <li>Communicate with you about our services</li>
                <li>Pray for submitted prayer requests</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="font-serif text-xl text-[#1C1917] mb-4">Information Sharing</h2>
              <p>
                We do not sell, trade, or rent your personal information to third parties. We may share your information only:
              </p>
              <ul className="list-disc pl-6 mt-2 space-y-2">
                <li>With your consent</li>
                <li>To comply with legal obligations</li>
                <li>To protect our rights or the safety of others</li>
                <li>With service providers who assist in our operations (under confidentiality agreements)</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="font-serif text-xl text-[#1C1917] mb-4">Data Security</h2>
              <p>
                We implement reasonable security measures to protect your personal information. However, no method of transmission over the Internet is 100% secure, and we cannot guarantee absolute security.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-serif text-xl text-[#1C1917] mb-4">Your Rights</h2>
              <p>
                You may request access to, correction of, or deletion of your personal information by contacting us at mark@stewardlots.org.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-serif text-xl text-[#1C1917] mb-4">Changes to This Policy</h2>
              <p>
                We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new policy on this page with an updated "Last updated" date.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-serif text-xl text-[#1C1917] mb-4">Contact Us</h2>
              <p>
                If you have questions about this Privacy Policy, please contact us at:
              </p>
              <p className="mt-2">
                <strong>Email:</strong>{" "}
                <a href="mailto:mark@stewardlots.org" className="text-[#BFA15F] hover:underline">
                  mark@stewardlots.org
                </a>
              </p>
            </section>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
